<template>
  <div id="gglist">
    <div class="gglist">
      <List :list="gglist" name="zcgl" :ShowTime="true"></List>
    </div>
  </div>
</template>

<script>
  import List from '@/components/list/List'
  import ajax from '@/common/ajax/ajax'
  import router from '@/router'
  export default {
    name: 'gglist',
    data () {
      return {
        gglist: []
      }
    },
    created: function () {
      this.$emit('update:titlestr', '资产管理公告')
      ajax.islogin().then(
        () => {
        },
        () => {
          router.replace({name: 'zcgl', params: {nr: 'login'}})
        }
      )
      ajax.getCfgllist().then(
        data => {
          this.gglist = data
        }
      )
    },
    components: {
      List
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../../common/stylus/common.styl"
  #gglist
    .gglist
      padding 0 $bj 0 $bj
      background-color #fff
      .List
        li
          margin 0
          .title
            margin-left 0
      .ShowMore
        display block
</style>



// WEBPACK FOOTER //
// gglist.vue?5382587c